module.exports = __webpack_public_path__ + "img/DataEase-black_bak.9ec6f903.png";